import React,{useRef} from 'react'
import { useNavigate } from 'react-router-dom'
import {Row,Col} from 'react-bootstrap'
import { useSelector} from "react-redux"
import { GET_Punkty } from '../Graphql/query'
import { useQuery } from '@apollo/client'
import BladLog from './BladLogowania'

import KonkursInfo from '../Konkursy/konkurs_informacja'
const Koniec = () => {
    const nawigacja = useNavigate()
    const id        = useSelector((magazyn) => magazyn.opcje)
    const uczestnik = useSelector((magazyn) => magazyn.uczestnik)
    const powrot = () => {
        let url = '/'
        nawigacja(url)
   } 
   const zmienneQuery = useRef({
    variables : {id_konkursu : Number(id.id_konkursu),id_uczestnika: Number(uczestnik.id)},
    fetchPolicy:'network-only'
})
   const token = uczestnik.token//sessionStorage.getItem('token')
   const {data,loading,error} = useQuery(GET_Punkty,zmienneQuery.current)
   if (loading) { return <p>Wczytywanie danych</p>}
   if (error) { if(!token) {return <BladLog/>} else { return <p>Błąd połacznia z bazą danych</p>}}
    return <div>
        <KonkursInfo/>        
         <Row>
            <Col xs={12}><h2 className='napis_left'>W tym konkursie uzyskano wynik</h2></Col>
         </Row>
         <Row className='wynik'>
            <Col xs={3}><p>Odpowiedzi poprawne :</p></Col>
            <Col xs={9}><p>{data.punkty.poprawne}</p></Col>
            <Col xs={3}><p>Odpowiedzi błędne</p></Col>
            <Col xs={9}><p>{data.punkty.bledne}</p></Col>
            <Col xs={3}><p>Brak odpowiedzi</p></Col>
            <Col xs={9}><p>{data.punkty.brak}</p></Col>
            <Col xs={3}><p className='sumaPunktow'>Suma punktów</p></Col>
            <Col xs={9}><p className='sumaPunktow'>{data.punkty.suma}</p></Col>
         </Row>
         <Row>   
            <Col xs={6}>
            <button className="btn btn-primary btn-lg btn-block mt-2 przycisk"
                        onClick={powrot}>Powrót</button>
            </Col><Col xs={6}></Col>
        </Row>
    </div>
}

export default Koniec